<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Position History"
      text="Update position record"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    outlined
                    readonly
                    label="Start Date"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"    
                    data-vv-as="start date"
                    :class="{
                      'required':!startDateDisplay
                    }"
                    class="label-position" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localStartDate"
                  :min="minStartDate"
                  :max="localEndDate"
                  @input="startDateMenu = false"
                />
              </v-menu>

              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    outlined
                    readonly
                    label="End Date"
                    :error-messages="errors.collect('endDateDisplay')"
                    data-vv-name="endDateDisplay"    
                    data-vv-as="end date"
                    :class="{
                      'required':!endDateDisplay
                    }"
                    class="label-position" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localEndDate"
                  :min="localStartDate"
                  :max="maxEndDate"
                  @input="endDateMenu = false"
                />
              </v-menu>              
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      positionRecord: {
        type: Object,
        required: true,
      },
      minStartDate: {
        type: String,
        required: true,
      },
      maxEndDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localPositionRecord: null,
        localStartDate: null,
        localEndDate: null,
        loading: false,
        startDateMenu: false,
        endDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localStartDate ? this.$moment(this.localStartDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
      endDateDisplay () {
        return this.localEndDate ? this.$moment(this.localEndDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localPositionRecord = { ...this.positionRecord }
        this.localStartDate = this.localPositionRecord.start_date
        this.localEndDate = this.localPositionRecord.end_date

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisEmployeePositions().update(this.positionRecord.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee position record updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          start_date: this.localStartDate,
          end_date: this.localEndDate,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background: white;
}
</style>
